import { render } from "./achievementRequirements.vue?vue&type=template&id=42568ff4&scoped=true"
import script from "./achievementRequirements.vue?vue&type=script&lang=js"
export * from "./achievementRequirements.vue?vue&type=script&lang=js"

import "./achievementRequirements.vue?vue&type=style&index=0&id=42568ff4&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42568ff4"]])

export default __exports__